import {LocalOfferOutlined, PauseCircleOutlined, SellOutlined} from '@mui/icons-material';
import {FC, ReactNode} from 'react';
import {useIntl} from 'react-intl';
import {StatsStrip} from 'src/components/common/StatsStrip';
import {StatsStripTone} from 'src/components/common/StatsStrip/StatsStrip.types';
import {TariffsStatusEnum} from 'src/enums';
import {TariffStatsStripType} from './TariffStatsStrip.types';

/** A tariff is either on sale or it is not; there is no third state. */
const STRIP_STATUSES: TariffsStatusEnum[] = [
    TariffsStatusEnum.ACTIVE,
    TariffsStatusEnum.DEACTIVATED,
];

const STATUS_ICONS: Record<string, ReactNode> = {
    [TariffsStatusEnum.ACTIVE]: <SellOutlined/>,
    [TariffsStatusEnum.DEACTIVATED]: <PauseCircleOutlined/>,
};

const STATUS_TONES: Record<string, StatsStripTone> = {
    [TariffsStatusEnum.ACTIVE]: 'success',
    // Withdrawn from sale rather than broken, so the same neutral an archived contract wears.
    [TariffsStatusEnum.DEACTIVATED]: 'neutral',
};

export const TariffStatsStrip: FC<TariffStatsStripType> = ({data, activeStatus, onSelectStatus}) => {
    const intl = useIntl();
    const counts = new Map((data?.statuses ?? []).map((point) => [point.status, point.tariffs]));

    return (
        <StatsStrip
            icon={<LocalOfferOutlined/>}
            title="tariffs"
            subtitle={intl.formatMessage({id: 'tariffStatsSubtitle'}, {tariffs: data?.tariffs ?? 0})}
            tiles={STRIP_STATUSES.map((status) => ({
                key: status,
                label: status,
                value: counts.get(status),
                icon: STATUS_ICONS[status],
                tone: STATUS_TONES[status],
                active: activeStatus === status,
                onClick: onSelectStatus ? () => onSelectStatus(status) : undefined,
            }))}
        />
    );
};
